var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"shift-link transparent",attrs:{"text":""}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-calendar-range")]),_c('span',[_vm._v(_vm._s(_vm.shift))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }